import React, { useEffect, useState } from "react";
import * as styles from "./header.module.scss";
import Logo from "../../assets/logo-and-text.svg";
import CloseIcon from "../../assets/close-icon.svg";
import MenuIcon from "../../assets/menu-icon.svg";
import { Link as LinkScroll } from "react-scroll";
import { Link } from "gatsby";

export const Header = ({ secondary }: any) => {
  const [scrollFixed, setScrollFixed] = useState(true);

  useEffect(() => {
    const body = document.body;
    const scrollDown = "scroll-down";
    const transparentBackground = "transparent-background";
    let lastScroll = 0;
    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll === 0) {
        body.classList.add(transparentBackground);
      } else {
        body.classList.remove(transparentBackground);
      }
      if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        // down
        body.classList.add(scrollDown);
      } else if (
        currentScroll < lastScroll &&
        body.classList.contains(scrollDown)
      ) {
        // up
        body.classList.remove(scrollDown);
      }
      lastScroll = currentScroll;
    });
  }, []);

  const stopScroll = () => {
    setScrollFixed(!scrollFixed);
    if (scrollFixed) document.body.classList.add("overflow-hidden");
    else document.body.classList.remove("overflow-hidden");
  };
  const activeStyleLink = {
    color: "#FB68AF",
    paddingBottom: "5px",
    borderBottom: "2px solid #FB68AF",
    fontWeight: 700,
    lineHeight: "35px",
  };
  return (
    <header className={styles["trigger-menu-wrapper"]}>
      <div className={styles.header}>
        <Link  to="/">
          <img src={Logo} alt="Flahmingo Logo" />
        </Link>
        <input type="checkbox" onChange={stopScroll} id="active" />
        <label htmlFor="active" className="menu-btn">
          <img src={MenuIcon} alt="Menu button" className="menu-icon" />
          <img src={CloseIcon} alt="close button" className="close-icon" />
        </label>
        <div className="wrapper_responsive">
          <nav>
            <Link className="link" to="/legal/privacy-policy/">
              Privacy Policy
            </Link>
            <Link className="link" to="/legal/terms-and-conditions/">
              Terms and Conditions
            </Link>
            <Link className="link" to="/legal/complaint-handling-process/">
              Complaint Handling Process
            </Link>
            <Link className="link" to="/fees-schedule/">
              Fee Schedule
            </Link>
            <Link className="link" to="https://flahmingo.applytojobs.ca/">
              Careers
            </Link>
          </nav>
        </div>
        <ul
          className={`${styles.header__menu} animated fadeIn fast`}
          id="myLinks"
        >
          {secondary ? (
            <>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/legal/privacy-policy/" activeStyle={activeStyleLink}>
                  Privacy policy
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/terms-and-conditions/"
                  activeStyle={activeStyleLink}
                >
                  Terms and Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/complaint-handling-process/"
                  activeStyle={activeStyleLink}
                >
                  Complaint Handling Process
                </Link>
              </li>
              <li>
                <Link to="/fees-schedule/" activeStyle={activeStyleLink}>
                  Fee Schedule
                </Link>
              </li>
            </>
          ) : (
            <>
              <li>
                <LinkScroll to="piesAndSlices" spy={true} smooth={true}>
                  Pies and Slices
                </LinkScroll>
              </li>
              <li>
                <LinkScroll to="fractionalShares" spy={true} smooth={true}>
                  Fractional Shares
                </LinkScroll>
              </li>
              <li>
                <LinkScroll to="theMagic" spy={true} smooth={true}>
                  The Magic
                </LinkScroll>
              </li>
              <li>
                <LinkScroll to="education" spy={true} smooth={true}>
                  Education
                </LinkScroll>
              </li>
            </>
          )}
        </ul>
      </div>
    </header>
  );
};
